import React from 'react';
import { CircularProgressbar } from 'react-circular-progressbar';

import * as Styled from './StyledProgressBar';

export const ProgressBarCircle = ({ strokeWidth, styles, value }) => (
    <Styled.ProgressBarCircle>
        <CircularProgressbar value={value} strokeWidth={strokeWidth} styles={styles} />
    </Styled.ProgressBarCircle>
);
